export const ASSIGNMENT_STATE_NR = 'nr'
export const ASSIGNMENT_STATE_MISSING = 'missing'
export const ASSIGNMENT_STATE_AUTO = 'auto'
export const ASSIGNMENT_STATE_AUTO_1 = 'auto 1'
export const ASSIGNMENT_STATE_AUTO_2 = 'auto 2'
export const ASSIGNMENT_STATE_AUTO_3 = 'auto 3'
export const ASSIGNMENT_STATE_BLIND_PLUS = 'blind plus'
export const ASSIGNMENT_STATE_BLIND_MINUS = 'Blind -'
export const ASSIGNMENT_STATE_POST = 'post'
export const ASSIGNMENT_STATE_TEAM_OK = 'team ok'
export const ASSIGNMENT_STATE_TEAM_OK_NR = 'team ok nr'
export const ASSIGNMENT_STATE_TEAM_OK_MISSING = 'team ok missing'
export const ASSIGNMENT_STATE_TEAM_KO = 'team ko'
